import { styled } from '@shared/ui/styled';

const PREFIX = 'InfoRow';

export const classes = {
  row: `${PREFIX}-row`,
  rowAction: `${PREFIX}-rowAction`,
  rowFlash: `${PREFIX}-rowFlash`,
  rowNoData: `${PREFIX}-rowNoData`,
  label: `${PREFIX}-label`,
  value: `${PREFIX}-value`,
  valueMono: `${PREFIX}-valueMono`,
  valueMuted: `${PREFIX}-valueMuted`,
  valueMultiline: `${PREFIX}-valueMultiline`,
  valuePill: `${PREFIX}-valuePill`,
  valuePillCritical: `${PREFIX}-valuePillCritical`,
  trail: `${PREFIX}-trail`,
};

const Root = styled('div')(() => ({
  display: 'contents',
  [`& .${classes.row}`]: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: '110px 1fr auto',
    alignItems: 'center',
    gap: 12,
    padding: '11px 20px',
    fontSize: 13,
    cursor: 'pointer',
    transition: 'background 120ms cubic-bezier(0.4, 0, 0.2, 1)',
    borderBottom: '1px solid transparent',
    '&:hover': { background: 'var(--qhs-surface-hover)' },
    '&:hover .trail': { opacity: 1 },
  },
  [`& .${classes.label}`]: {
    fontSize: 12,
    fontWeight: 500,
    color: 'var(--qhs-text-2)',
    lineHeight: 1.5,
    paddingTop: 1,
  },
  [`& .${classes.value}`]: {
    fontSize: 13,
    fontWeight: 500,
    color: 'var(--qhs-text-1)',
    lineHeight: 1.5,
    wordBreak: 'break-word',
    minWidth: 0,
  },
  [`& .${classes.valueMono}`]: {
    fontFamily: 'var(--qhs-font-mono)',
    fontSize: 12.5,
  },
  [`& .${classes.valueMuted}`]: {
    color: 'var(--qhs-text-3)',
    fontWeight: 400,
  },
  [`& .${classes.valueMultiline}`]: {
    whiteSpace: 'pre-line',
  },
  // Status-tone pill treatment for rows that carry a `tone` prop
  // (e.g. the Engagement status row while the flag is off).
  [`& .${classes.valuePill}`]: {
    display: 'inline-flex',
    alignItems: 'center',
    width: 'fit-content',
    padding: '1px 8px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '18px',
  },
  [`& .${classes.valuePillCritical}`]: {
    background: 'var(--qhs-st-critical-bg)',
    color: 'var(--qhs-st-critical-tx)',
  },
  [`& .${classes.trail}`]: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: 6,
    opacity: 0,
    color: 'var(--qhs-text-3)',
    transition: 'opacity 150ms ease, background 120ms ease, color 120ms ease',
    '& svg': { width: 14, height: 14 },
  },
  [`& .${classes.row}:hover .${classes.trail}`]: {
    background: 'rgba(46, 72, 211, 0.06)',
    color: 'var(--qhs-brand)',
  },
  [`& .${classes.rowAction} .${classes.value}`]: {
    color: 'var(--qhs-brand)',
    textDecoration: 'underline',
    textDecorationColor: 'rgba(46, 72, 211, 0.25)',
    textUnderlineOffset: 2,
  },
  [`& .${classes.rowAction} .${classes.trail}`]: { opacity: 1, color: 'var(--qhs-brand)' },
  [`& .${classes.rowNoData}`]: {
    cursor: 'default',
    '&:hover': { background: 'transparent' },
    [`& .${classes.trail}`]: { display: 'none' },
  },
  [`& .${classes.rowFlash}`]: {
    animation: 'ipFlash 1.5s ease-out',
  },
  '@keyframes ipFlash': {
    '0%': { background: 'rgba(255, 200, 0, 0.18)' },
    '100%': { background: 'transparent' },
  },
}));

export default Root;
